// localhost: http://127.0.0.1:5000
// api: https://mellori-v2-api.herokuapp.com

const localhost = "http://127.0.0.1:5000"
const herokuAPI = "https://mellori-v2-api.herokuapp.com"

export const Api = herokuAPI